import React from 'react'
import { Text } from '@/components/atoms/Text'
import './Question.css'

export interface QuestionProps {
  text: string
  className?: string
}

export const Question: React.FC<QuestionProps> = ({
  text,
  className = '',
}) => {
  return (
    <div className={`question ${className}`}>
      <Text size="small" color="gray" weight="normal" className="question-text">
        {text}
      </Text>
    </div>
  )
}
